// Local translations
export const T = {
  en_GB: {
    previewAlt: "Preview",
    image: "Image",
    uploading: "Uploading...",
    helpText: "Upload PNG, SVG, JPG, GIF, or WebP (max 5MB). Animated GIFs supported.",
    preview: "Preview",
    invalidFileType: "Please upload a PNG, SVG, JPG, GIF, or WebP image",
    fileTooLarge: "Image size must be less than 5MB",
    uploadFailed: "Failed to upload image. Please try again.",
  },
  nb_NO: {
    previewAlt: "Forhåndsvisning",
    image: "Bilde",
    uploading: "Laster opp...",
    helpText: "Last opp PNG, SVG, JPG, GIF eller WebP (maks 5MB). Animerte GIF-er støttes.",
    preview: "Forhåndsvisning",
    invalidFileType: "Vennligst last opp et PNG, SVG, JPG, GIF eller WebP-bilde",
    fileTooLarge: "Bildestørrelsen må være mindre enn 5MB",
    uploadFailed: "Kunne ikke laste opp bilde. Vennligst prøv igjen.",
  },
} as const;
